import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { deleteReportTemplate } from "services/ReportTemplates.services";
import { toast } from "sonner";

import { queryClient } from "utils/queryClient";

export default function useDeleteTemplateDialog() {
  const { t } = useTranslation();

  const deleteReportTemplateMutation = useMutation({
    mutationFn: (id: string) => deleteReportTemplate(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["reportTemplates"] });
      toast.success(t("profile.reportTemplates.deleteReportTemplateSuccess"));
    },
    onError: () => {
      toast.error(t("profile.reportTemplates.deleteReportTemplateError"));
    },
  });

  return { deleteReportTemplateMutation };
}
